"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeBitrate = exports.monitorFrequency = void 0;
exports.monitorFrequency = 2000;
function computeBitrate(currentStats, prevStats) {
    if (!prevStats) {
        return 0;
    }
    let bytesNow;
    let bytesPrev;
    if ('bytesReceived' in currentStats) {
        bytesNow = currentStats.bytesReceived;
        bytesPrev = prevStats.bytesReceived;
    }
    else if ('bytesSent' in currentStats) {
        bytesNow = currentStats.bytesSent;
        bytesPrev = prevStats.bytesSent;
    }
    if (bytesNow === undefined || bytesPrev === undefined
        || currentStats.timestamp === undefined || prevStats.timestamp === undefined) {
        return 0;
    }
    return ((bytesNow - bytesPrev) * 8 * 1000) / (currentStats.timestamp - prevStats.timestamp);
}
exports.computeBitrate = computeBitrate;
//# sourceMappingURL=stats.js.map